<h1 class="mb-4">Szczegóły użytkownika</h1>

@if (selectedUser(); as user) {
  <p-tabs value="0" lazy [class]="'customTab'">
    <p-tablist>
      <p-tab value="0">Dane użytkownika</p-tab>
      <p-tab value="1">Historia zdarzeń</p-tab>
      <p-tab value="2">Korespondencja</p-tab>
    </p-tablist>
    <p-tabpanels>
      <p-tabpanel value="0">
        <app-admin-panel-user-details
          [userId]="user.id"
          [userDetailsInput]="user.details"
        ></app-admin-panel-user-details>
      </p-tabpanel>
      <p-tabpanel value="1">
        <app-admin-panel-user-events-history-table
          [userDetails]="user.details"
        ></app-admin-panel-user-events-history-table>
      </p-tabpanel>
      <p-tabpanel value="2">
        <app-admin-panel-user-correspondence-table
          [userDetails]="user.details"
        ></app-admin-panel-user-correspondence-table>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
}
